import React from 'react';
import { Paragraph, StackedColumn } from '../../../core';
import { AlertDialog } from '../../../core/components/dialogs/alertDialog';

interface AppointmentRemindersDialogProps {
  isOpen: boolean;
  emailAddress?: string;
  onClose: () => void;
}

const AppointmentRemindersDialog: React.FC<AppointmentRemindersDialogProps> = (
  props: AppointmentRemindersDialogProps
) => {
  const line1 =
    props.emailAddress && props.emailAddress.length > 0
      ? `A confirmation email will be sent to ${props.emailAddress}`
      : 'If we have your email address on file, you will receive a confirmation email.';

  return (
    <AlertDialog
      title="Appointment reminders"
      isOpen={props.isOpen}
      onDismiss={props.onClose}
      maxWidth={400}
    >
      <StackedColumn>
        <Paragraph text={line1} />
        <Paragraph text="Print this page or add to your calendar. You can update your notification preferences in person when you arrive for your appointment." />
      </StackedColumn>
    </AlertDialog>
  );
};

export default AppointmentRemindersDialog;
